export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const LOAD_PERMISSIONS = 'LOAD_PERMISSIONS'


